import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SyncratikLogo } from '../common/SyncratikLogo';
import LoginModal from '../../components/dashboard/LoginModal';
import { hasValidSession } from "../../utils/session";
import { Menu, X } from 'lucide-react';

const Navbar = () => {
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    const handleLoginClick = () => {
        // if (hasValidSession()) {
        //     // Determine dashboard URL based on environment
        //     const dashboardUrl = getDashboardUrl();
        //     window.location.href = dashboardUrl;
        // } else {
        //     setIsLoginOpen(true);
        // }

        // Determine dashboard URL based on environment
        const dashboardUrl = getDashboardUrl();
        window.location.href = dashboardUrl;
    };

    const getDashboardUrl = () => {
        // Check if running locally (development)
        const isLocal = window.location.hostname === 'localhost' ||
            window.location.hostname === '127.0.0.1' ||
            window.location.hostname === 'local.dashboard.syncratik' ||
            process.env.NODE_ENV === 'development';

        if (isLocal) {
            return 'http://localhost:7287';
        } else {
            return 'https://dashboard.syncratik.com/';
        }
    };

    return (
        <>
            <nav className="bg-gray-10 sticky top-0 left-0 w-full z-50">
                <div className="container-wide py-2 flex justify-between items-center">

                    {/* Logo */}
                    <Link to="/" className="cursor-pointer flex items-center space-x-2">
                        <SyncratikLogo className="h-8 w-8" />
                        <h3 className="text-gray-95 text-xl font-sansation tracking-wide">SYNCRATIK</h3>
                    </Link>

                    {/* Desktop Navigation */}
                    <div className="hidden md:flex items-center space-x-8">
                        {/* Links */}
                        <div className="flex items-center space-x-6">
                            <Link to="/about" className="text-gray-90 hover:text-purple-60 transition duration-300 text-sm">About</Link>
                            <Link to="/pricing" className="text-gray-90 hover:text-purple-60 transition duration-300 text-sm">Pricing</Link>
                            <Link to="/news" className="text-gray-90 hover:text-purple-60 transition duration-300 text-sm">News</Link>
                        </div>

                        {/* Separator */}
                        <div className="h-8 w-px bg-gray-25"></div>

                        {/* Buttons */}
                        <div className="flex items-center space-x-3">
                            <Link to="/contact" className="btn-primary-outline">Talk to Us</Link>
                            <button onClick={handleLoginClick} className="btn-primary">Log In</button>
                        </div>
                    </div>

                    {/* Mobile Hamburger */}
                    <div className="md:hidden flex items-center">
                        <button
                            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                            className="relative w-6 h-6 flex flex-col justify-center items-center"
                            aria-label="Toggle menu"
                        >
                            <span
                                className={`absolute h-0.5 w-6 bg-gray-90 transform transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'rotate-45' : '-translate-y-2'
                                    }`}
                            />
                            <span
                                className={`absolute h-0.5 w-6 bg-gray-90 transition-all duration-300 ease-in-out ${isMobileMenuOpen ? 'opacity-0' : 'opacity-100'
                                    }`}
                            />
                            <span
                                className={`absolute h-0.5 w-6 bg-gray-90 transform transition-all duration-300 ease-in-out ${isMobileMenuOpen ? '-rotate-45' : 'translate-y-2'
                                    }`}
                            />
                        </button>
                    </div>
                </div>

                {/* Mobile Menu Overlay */}
                <div className={`fixed inset-0 z-40 transition-opacity duration-300 ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
                    }`}>
                    <div
                        className="absolute inset-0 bg-gray-10/60"
                        onClick={() => setIsMobileMenuOpen(false)}
                    />
                    <div className={`absolute top-0 left-0 right-0 bg-gray-10/95 backdrop-blur-md shadow-xl transform transition-all duration-300 ease-out ${isMobileMenuOpen ? 'translate-y-[60px] opacity-100' : 'translate-y-0 opacity-0'
                        }`}>
                        <div className="container-content py-3">
                            <nav className="flex flex-col space-y-3">
                                <Link onClick={() => setIsMobileMenuOpen(false)} to="/about" className="text-paragraph text-gray-80 hover:text-gray-95 transition">About</Link>
                                <Link onClick={() => setIsMobileMenuOpen(false)} to="/pricing" className="text-paragraph text-gray-80 hover:text-gray-95 transition">Pricing</Link>
                                <Link onClick={() => setIsMobileMenuOpen(false)} to="/news" className="text-paragraph text-gray-80 hover:text-gray-95 transition">News</Link>
                                <div className="h-px bg-gray-25 my-2"></div>
                                <Link onClick={() => setIsMobileMenuOpen(false)} to="/contact" className="btn-primary-outline text-center">Talk to Us</Link>
                                <button onClick={handleLoginClick} className="btn-primary">Log In</button>
                            </nav>
                        </div>
                    </div>
                </div>

            </nav>

            {/* Render modal if open */}
            {isLoginOpen && <LoginModal onClose={() => setIsLoginOpen(false)} />}
        </>
    );
};

export default Navbar;

